import { createFileRoute, Navigate } from "@tanstack/react-router";
import { Box, Spinner } from "@salestrak/ui";

import { useWorkspace } from "#app/lib/data/workspace-context";
import { useUserSettings } from "#app/lib/hooks/use-user-settings";
import { getDefaultRouteSuffix } from "#app/lib/default-route";

function AppIndex() {
  const { activeWorkspace } = useWorkspace();
  const { preferences, isLoading } = useUserSettings();

  if (!activeWorkspace) {
    return <Navigate to="/workspace-select" />;
  }

  if (isLoading && !preferences) {
    return (
      <Box fill="flex" align="center" justify="center">
        <Spinner />
      </Box>
    );
  }

  const base = `/${activeWorkspace.urlPath}`;
  const suffix = getDefaultRouteSuffix(preferences?.defaultRoute);

  return <Navigate to={`${base}${suffix}` as unknown as "/"} />;
}

export const Route = createFileRoute("/(app)/")({ component: AppIndex });
